/**
 * @typedef {Object} dashbaordState
 */
export default {
  selectedBusiness: null,
  managers: [],
  manager: null,
};

